(function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // scroll reveal
    var items = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { io.observe(el); });
    } else {
      items.forEach(function (el) { el.classList.add('in'); });
    }

    // smooth scroll for data-scroll buttons
    document.querySelectorAll('[data-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.querySelector(btn.getAttribute('data-scroll'));
        if (target) target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      });
    });

    // nav smooth scroll
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var id = a.getAttribute('href');
        var target = document.querySelector(id);
        if (target) {
          ev.preventDefault();
          target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        }
      });
    });
  })();

(function () {
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var buttons = gallery.querySelectorAll('[data-gallery-thumb]');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');

    if (!buttons.length || !slides.length) return;

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var mediaId = button.getAttribute('data-gallery-thumb');

        slides.forEach(function (slide) {
          var active = slide.getAttribute('data-gallery-slide') === mediaId;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);

          if (!active) {
            slide.querySelectorAll('video').forEach(function (video) {
              try { video.pause(); } catch (e) {}
            });
          }
        });

        buttons.forEach(function (thumb) {
          var active = thumb === button;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      });
    });
  });
})();
